/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-11-29 14:05:30
 *
 *******************************************************/
// @flow

import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import Banner from 'src/components/views/common/banners/pfs-banner-custom';
import { URL } from 'src/constants/links';

import imageBanner from 'src/assets/images/banners/stop-words-guide.png';
import waveIcon from 'src/assets/images/common/wave-icon.png';

const DidYouKnow = props => {
  const { i18n } = props;

  const handleLearnMore = () => {
    window.open(URL['Link_V2_Search_StopWords_ManualGuide'], '_blank');
  };

  return (
    <Banner
      name="stopWordsInfos"
      title={i18n.translate('AdminHTML.StopWords.DidYouKnow.title')}
      titleIcon="book"
      status="success"
      backgroundImage={waveIcon}
      image={imageBanner}
      action={{
        content: i18n.translate('AdminHTML.Common.Action.learnMore'),
        onAction: () => handleLearnMore()
      }}
      allowDismiss={true}>
      <div style={{ minHeight: '92px' }}>
        {i18n.translate('AdminHTML.StopWords.DidYouKnow.content')}
      </div>
    </Banner>
  );
};

export default withI18n()(DidYouKnow);
